export default {
  noOptions: 'No options found',
  start: 'start',
  next: 'Next',
  back: 'Back',
  of: 'of',
  confirm: 'Confirm',
  no_results: 'No results found!',
  yes: 'yes',
  no: 'no',
  cancel: 'Cancel',
  reason: 'Reason',
  remove: 'remove',
  change: 'Change',
  apply: 'Apply',
  date: 'Date',
  edit: 'Edit',
  total: 'Total',
  send: 'Send',
  resend: 'Resend',
  continue: 'Continue',
  previous: 'Previous',
  customer_service: 'Customer service',
  link_account: 'Link account',
  enter_placeholder: 'Enter {{name}}',
  select_placeholder: 'Select {{name}}',
  choose_placeholder: 'Choose {{name}}',
  retry: 'Retry',
  all: 'All',
  save: 'Save',
  downloading: 'Downloading',
  select: 'Select',
  benefitsExpiryDateLabel: 'Exp: <date>{{expiryDate}}</date>',
  'iban_blocked_hours#one': '{{count}} hour and ',
  'iban_blocked_hours#two': '{{count}} hours and ',
  'iban_blocked_hours#few': '{{count}} hours and ',
  'iban_blocked_hours#many': '{{count}} hours and ',
  'iban_blocked_hours#other': '{{count}} hours and ',
  'iban_blocked_minutes#one': '{{count}} minute',
  'iban_blocked_minutes#two': '{{count}} minutes',
  'iban_blocked_minutes#few': '{{count}} minutes',
  'iban_blocked_minutes#many': '{{count}} minutes',
  'iban_blocked_minutes#other': '{{count}} minutes',
} as const
